export * from './ErrorPageCard';
export * from './ErrorPageCard.type';
